/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require v4/certificates

window.DocumentSetsBidderDocuments = {

  _showOnDropDown(target) {
    target.parents('ul').find('a').removeClass('selected');
    target.addClass('selected');
    return target.parents('ul').parent().find('span').text(target.html());
  },

  _resetSelectAllCheckBox() {
    $('#select-all-bidder-documents').prop('checked', false);
    return $('.dropdown-bidder-document-actions').attr('disabled', true);
  },

  _sort(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const name = $target.data('sort-name');
    this._showOnDropDown($target);
    const currentSort = this._gridApi.getColumnState().filter(c => c.sort);
    const direction = currentSort.length > 0 ?
      currentSort[0].sort == 'asc' ? 'desc' : 'asc'
      :
      'asc';

    const sort = [
      { colId: name, sort: direction }
    ];
    this._gridApi.applyColumnState({ state: sort, defaultState: { sort: null } });
    this._gridApi.redrawRows();
    return this._resetSelectAllCheckBox();
  },

  _gridApi: null,

  _gridOptions: {
    rowData: null,
    rowHeight: 69,
    suppressRowTransform: true,
    headerHeight: 0,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridReady(event) {
      return event.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    }
  },

  _onSelectDocument() {
    return $('.dropdown-bidder-document-actions').attr('disabled', $('.select-bidder-document:checked').length === 0);
  },

  _onSelectAllDocuments(event) {
    const isChecked = $(event.currentTarget).is(':checked');
    $('.select-bidder-document').prop('checked', isChecked);
    return $('.dropdown-bidder-document-actions').attr('disabled', !isChecked);
  },

  _selectedBidderDocumentIds(event) {
    const selectedDocuments = $('.select-bidder-document:checked').map(function () { return $(this).val(); });
    return selectedDocuments.toArray();
  },

  _onDownloadDocuments(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    return location.href = `${$target.attr('href')}?selected_ids=${this._selectedBidderDocumentIds().join()}`;
  },

  _initializeActions() {
    $(document).on('click', '.bidder-document-sort', _.bind(this._sort, this));
    $(document).on('click', '.select-bidder-document', _.bind(this._onSelectDocument, this));
    $(document).on('click', '#select-all-bidder-documents', _.bind(this._onSelectAllDocuments, this));
    return $(document).on('click', '#download-bidder-documents-action', _.bind(this._onDownloadDocuments, this));
  },

  initializeTable(tableSelector, params) {
    const data = _.map(params, doc => JSON.parse(doc));

    const columnDefs = [
      {
        headerName: 'Document Bidder',
        cellRenderer: doc => escapeHTML(doc.data.partial),
        width: 10000
      },
      {
        headerName: 'title',
        field: 'title',
        hide: true,
        valueGetter(doc) { return doc.data.title; }
      },
      {
        headerName: 'class_name',
        field: 'class_name',
        hide: true,
        valueGetter(doc) { return doc.data.class_name; }
      },
      {
        headerName: 'updated_at',
        field: 'updated_at',
        hide: true,
        valueGetter(doc) { return doc.data.updated_at; }
      }
    ];

    this._gridOptions['onFilterChanged'] = event => {
      return resizeAgGridTable('#bidder-document-grid', this._gridOptions);
    };
    this._gridOptions['rowData'] = data;
    this._gridOptions['columnDefs'] = columnDefs;

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return this._initializeActions();
  }
};
